export enum OTHER_DETAILS_TYPE {
    Features = 'FEATS',
    Financing = 'BANKS',
    Properties = 'PROPS',
    Designs = 'ADS_FILE',
    Services = 'SERVICES',
}